import { render, staticRenderFns } from "./LotteryOffers.vue?vue&type=template&id=6e4c315b&scoped=true&"
import script from "./LotteryOffers.vue?vue&type=script&lang=js&"
export * from "./LotteryOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c315b",
  null
  
)

export default component.exports